import { IWindowSize } from 'types/common';
import { useEffect, useState } from 'react';

export function useWindowSize() {
  const [windowSize, setSize] = useState<IWindowSize | null>({
    wHeight: window.innerHeight,
    wWidth: window.innerWidth,
  });

  useEffect(() => {
    const onResize = () => {
      setSize({ wHeight: window.innerHeight, wWidth: window.innerWidth });
    };
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return windowSize;
}
